import React from 'react';
import { IconsPros } from './types';

/**
 * Search Icon component
 *
 * @returns JSX.ELEMENT
 */
export const SearchIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M15.93,13.93,11.14,9.08A6,6,0,0,0,6,0H6A5.82,5.82,0,0,0,1,2.73c-.06.1-.11.2-.17.3l-.1.18c-.07.14-.14.28-.2.42l-.06.15a5.88,5.88,0,0,0-.26.85c0,.06,0,.13,0,.19s0,.27-.06.41,0,.23,0,.35,0,.2,0,.29S0,6,0,6a6,6,0,0,0,9.19,5.08L14,15.93a.25.25,0,0,0,.35,0l1.61-1.64A.26.26,0,0,0,15.93,13.93ZM8.65,8.65a3.75,3.75,0,1,1,0-5.3A3.75,3.75,0,0,1,8.65,8.65Z" />
    </svg>
  );
};
